import React, { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { AppLoader } from '../AppLoader';

export interface PublicShellProps {}

export const PublicShell = (props: PublicShellProps) => (
    <Suspense fallback={<AppLoader />}>
        <Outlet />
    </Suspense>
);
